module.exports = __webpack_public_path__ + "static/media/icn-providers-v2.7e55acc0.svg";